var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOrangeWhiteMap(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 24,
    viewBox: "0 0 27 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.00772 4.82416C1.38457 5.18024 1 5.84293 1 6.56065V19.5536C1 21.0893 2.65896 22.052 3.99228 21.2901L7.77066 19.1311C8.35126 18.7993 9.05926 18.7796 9.65737 19.0787L16.5426 22.5213C17.1407 22.8204 17.8487 22.8007 18.4293 22.469L24.1923 19.1758C24.8154 18.8198 25.2 18.1571 25.2 17.4394V4.44636C25.2 2.91071 23.541 1.94798 22.2077 2.70987L18.4293 4.86895C17.8487 5.20072 17.1407 5.22037 16.5426 4.92132L9.65737 1.47868C9.05926 1.17963 8.35126 1.19928 7.77066 1.53105L2.00772 4.82416Z",
    fill: "#FFFEF9",
    stroke: "#E65402",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.69995 1V18.6",
    stroke: "#E65402",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 5.4V23",
    stroke: "#E65402",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrangeWhiteMap);
export default __webpack_public_path__ + "static/media/orange_white_map.c18648e03b13ab8092317372d738c4eb.svg";
export { ForwardRef as ReactComponent };